import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DriverJourneyDialogComponent } from './driver-journey-dialog.component';
import { DriverStoreModule } from '../../../store/driver/driver.module';

@NgModule({
  imports: [CommonModule, DriverStoreModule, MatDialogModule, MatButtonModule, MatProgressSpinnerModule],
  exports: [DriverJourneyDialogComponent],
  declarations: [DriverJourneyDialogComponent]
})
export class DriverJourneyDialogModule {}
